import React from "react";
import { useLocation } from "react-router-dom";
import { useState, useEffect,useLayoutEffect } from "react";
import "./checkout.css";
import lawService from "./simpleAjax.js";
import customLawService from "./customAjax.js";
import { jwtDecode } from "jwt-decode";
import lawpayService from "./lawpay.js";

////////////////ignore, unfinished integration


function Checkout() {
  const location = useLocation();
  const [lawpayData, setLawpayData] = useState({});
  console.log(location);
  // const listenerCallback = (m) => {
  //   //console.log(m.data);
  //   if (m.data.type === "pd:page_success") {
  //       if (location.state.isCustom === true) {
  //       if (location.state.pushQuantObj.clientId) {
  //         customLawService
  //           .markPayment(location.state.pushQuantObj.clientId)
  //           .then((r) => {
  //             console.log("mark payment", r);
  //           })
  //           .catch((e) => {
  //             console.log("mark jpaymetn,", e);
  //           });
  //         //   .then(alert("payment Marked"))
  //         //   .catch(alert("error marking payment"))
  //         customLawService
  //           .pushCustomQuants(
  //             location.state.pushQuantObj.clientId,
  //             location.state.pushQuantObj.WealthGuard,
  //             location.state.pushQuantObj.RLTProv,
  //             location.state.pushQuantObj.livingSNT,
  //             location.state.pushQuantObj.livingSNTRLT,
  //             location.state.pushQuantObj.LLCFormation,
  //             location.state.pushQuantObj.LLCWealth,
  //             location.state.pushQuantObj.IDGT,
  //             location.state.pushQuantObj.MAPT,
  //             location.state.pushQuantObj.DAPT,
  //             location.state.pushQuantObj.CRUT,
  //             location.state.pushQuantObj.LAPT,
  //             location.state.pushQuantObj.CMT,
  //             location.state.pushQuantObj.deeds,
  //             location.state.pushQuantObj.assignments,
  //             location.state.pushQuantObj.notary,
  //             location.state.pushQuantObj.lawmaticsInputString,
  //             location.state.pushQuantObj.totalToPush,
  //             location.state.pushQuantObj.eRecording,
  //             location.state.pushQuantObj.waveFee,
  //             location.state.pushQuantObj.deedsToBeDrafted
  //           )
  //           .then((r) => {
  //             console.log("custompush", r);
  //           })
  //           .catch((e) => {
  //             console.log("custompush,", e);
  //           });
  //         customLawService
  //           .changeAttorney(
  //             location.state.pushQuantObj.clientId,
  //             location.state.leadAttorneyId
  //           )
  //           .then((r) => {
  //             console.log("change attorney", r);
  //           })
  //           .catch((e) => {
  //             console.log("changeATtorye,", e);
  //           });
  //       }
  //     }
  //   }
  // };

  

  // const decodedToken = jwtDecode(token);
  useEffect(() => {
    lawpayService.getJwt().then((r) => {
      setLawpayData((ps) => {
        const pd = {
          ...ps,
        };
        pd.amount = "20000";
        pd.publicKey="m_bRxVaZgRSMyc1wKjuAs3Fw";
        pd.token=r.data.access_token;
        pd.bankId="7GmjHY8RBjm7rqgHOZKPNn"
        return pd;
      });

    });
    document.addEventListener('UPFChargeSuccess', listenerCallback);
  }, []);

 const listenerCallback=()=>{
  console.log('success')
 }
  return (
    <>
   
      <div className='checkoutDiv'>
   { lawpayData.token && 
   <upf-checkout
      test-mode="true"
      amount="100"
      public-key="m_bRxVaZgRSMyc1wKjuAs3Fw"
      bank-account-id="7GmjHY8RBjm7rqgHOZKPNn"
      token={lawpayData.token}
      //token="eyJhbGciOiJSUzI1NiIsImt2ciI6MX0.eyJpc3MiOiJJRCBTZXJ2aWNlIiwiaWF0IjoxNzI5ODk0MjM5LCJqdGkiOiJ6ZHF5cS1TOGpVX1BIb1dNNlVKLWpFb0p0TFRaSkNDTTd1c2hTSEJfZWRnIiwic2NvcGVzIjpbImNoYXJnZSIsInBheW1lbnRfbWV0aG9kcyJdLCJleHAiOjE3Mjk4OTQ4MzksImNpZCI6IjNhYTFjMmMxYzIwMjFjZDFjMjAzOGZlM2UzM2VjMTJkYTRmYmE4OTY1MmZmZGU5ZjYzMmUzZjVkMDNjYTQ0NDMiLCJzdWIiOiI2QjlQeWNOcWhYckVqMHBtMENJemk5IiwibWlkIjoiMXZGeDZPS09SUlk5dnFnc0I1UUNETSIsInRpZCI6IjY5c2Qwa1VOakt4YjBubXpqcFpTVWMiLCJyb2xlcyI6WyJtLWFkbWluIiwibS1jb2xsZWN0IiwibS1zY2hlZHVsZSIsIm0tdm9pZC1yZWZ1bmQiLCJtLXRhZyIsIm0tcmVwb3J0cyIsIm0tZGV2IiwibS1pbnYiLCJtLXZhdWx0LXdyaXRlciIsIm0tc3RhdGVtZW50cyIsIm0tcGNpLWNvbXBsaWFuY2UiXSwiZW50Ijp7InBheW1lbnRzIjpbIm0tYWRtaW4iLCJtLWNvbGxlY3QiLCJtLXNjaGVkdWxlIiwibS12b2lkLXJlZnVuZCIsIm0tdGFnIiwibS1yZXBvcnRzIiwibS1kZXYiLCJtLWludiIsIm0tdmF1bHQtd3JpdGVyIiwibS1zdGF0ZW1lbnRzIiwibS1wY2ktY29tcGxpYW5jZSJdLCJ2dCI6W119fQ.t9h9VQyc78KkYJZJ9hk30q1P2oXDQ11-Nq4ufebusUUPkThdiajmnqH0ELUoffn6k9s9caaRCu293QusiOuGCPqFuY9rcDRnOt8fkdDQYE8_g8Rihu7LaK2d2e41NigoRC7Ew9zFobTm_yYw7yJUuxeH2xe0QWlzMekuH_GZ1yDPUdEVzUmTVk8gOhHVsFymQNq9fp8tP058b_-a5Y6vQgEt6o8rRXiERBJiHidTA1QYX27cQkGGex4WSlpA9mKB8mGdps_OJ12EQeYlvptCA4LeumwL4-T53Z3hVnd-9yprepJ2iFa_jyrCAq4SBLdjFKKNSeixDaOPOe4pkJqFdg"
    ></upf-checkout>}
      
    </div>
    </>
  );
}

export default Checkout;
